import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var WeatherSunny = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, Object.assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4l-1 2.934L11 4a1.056 1.056 0 112 0zm-9 7l2.934 1L4 13a1.056 1.056 0 110-2zm7 9l1-2.934L13 20a1.056 1.056 0 11-2 0zm9-7.002l-2.934-1 2.934-1a1.056 1.056 0 110 2zM7.05 5.636l1.367 2.781L5.636 7.05A1.057 1.057 0 117.05 5.636zM5.636 16.949l2.781-1.367-1.367 2.781a1.057 1.057 0 11-1.414-1.414zm11.313 1.414l-1.367-2.781 2.781 1.367a1.057 1.057 0 11-1.414 1.414zm1.413-11.315L15.58 8.416l1.368-2.782a1.057 1.057 0 111.414 1.414zM12 16.5c-2.481 0-4.5-2.019-4.5-4.5S9.519 7.5 12 7.5s4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zm0-7c-1.379 0-2.5 1.121-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.121-2.5-2.5-2.5z"
  }));
});
WeatherSunny.displayName = 'WeatherSunny';
export var WeatherSunnyDimensions = {
  height: 24,
  width: 24
};